(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* Quantity steppers (product, builder) */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var current = parseInt(input.value, 10) || 1;
    var next = minus ? Math.max(1, current - 1) : current + 1;
    input.value = next;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Collection sort */
  var sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* Product page: gallery thumbnails and variant selection */
  var product = $('[data-product]');
  if (product) {
    var mainImage = $('#product-main-image', product);

    $$('[data-thumb]', product).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!mainImage) return;
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = btn.getAttribute('data-thumb');
      });
    });

    var json = $('[data-variants-json]', product);
    var variants = [];
    try { variants = json ? JSON.parse(json.textContent) : []; } catch (err) { variants = []; }
    var currency = product.getAttribute('data-currency') || 'USD';
    var addButton = $('[data-add-to-cart]', product);
    var variantInput = $('[data-variant-id]', product);
    var priceEl = $('[data-price]', product);

    var updateVariant = function () {
      var selected = $$('.option', product)
        .filter(function (fs) { return fs.querySelector('.option__input'); })
        .map(function (fs) {
          var checked = fs.querySelector('.option__input:checked');
          return checked ? checked.value : null;
        });

      $$('[data-option-selected]', product).forEach(function (el, i) {
        el.textContent = selected[i] || '';
      });

      var match = variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      })[0];

      if (!match) {
        addButton.disabled = true;
        addButton.textContent = addButton.getAttribute('data-unavailable-label');
        return;
      }

      variantInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price, currency);
      addButton.disabled = !match.available;
      addButton.textContent = match.available
        ? addButton.getAttribute('data-add-label')
        : addButton.getAttribute('data-soldout-label');

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }

      if (mainImage && match.featured_image && match.featured_image.src) {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = match.featured_image.src;
      }
    };

    $$('.option__input', product).forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });
  }

  /* Design builder: live preview, summary and cart properties */
  var builder = $('[data-builder]');
  if (builder) {
    var SHAPES = {
      tee: 'M70 20 L40 35 L10 70 L35 90 L55 75 L55 180 L145 180 L145 75 L165 90 L190 70 L160 35 L130 20 C125 35 75 35 70 20 Z',
      long: 'M70 20 L38 32 L6 140 L30 148 L55 80 L55 180 L145 180 L145 80 L170 148 L194 140 L162 32 L130 20 C125 35 75 35 70 20 Z',
      hood: 'M70 24 L38 34 L6 140 L30 148 L55 84 L55 180 L145 180 L145 84 L170 148 L194 140 L162 34 L130 24 C128 -4 72 -4 70 24 Z'
    };
    var HOOD = 'M66 24 C60 0 140 0 134 24 C128 42 72 42 66 24 Z';
    var POCKET = 'M72 138 L128 138 L136 166 L64 166 Z';
    var AREAS = {
      front: { x: 72, y: 60, w: 56, h: 60, cx: 100, cy: 92, fs: 7, text: 'YOUR ART' },
      back: { x: 72, y: 50, w: 56, h: 70, cx: 100, cy: 88, fs: 7, text: 'YOUR ART' },
      chest: { x: 108, y: 52, w: 24, h: 24, cx: 120, cy: 66, fs: 4, text: 'LOGO' }
    };

    var state = { shape: 'tee', hex: '#17181A', area: 'front', garment: '', color: '', placement: '' };

    var shapeEl = $('[data-b-shape]', builder);
    var hoodEl = $('[data-b-hood]', builder);
    var pocketEl = $('[data-b-pocket]', builder);
    var areaEl = $('[data-b-area]', builder);
    var labelEl = $('[data-b-label]', builder);
    var viewEl = $('[data-b-view]', builder);
    var qtyInput = $('[data-b-qty]', builder);
    var pricePerPiece = parseInt(builder.getAttribute('data-price'), 10) || 0;
    var currencyCode = builder.getAttribute('data-currency') || 'USD';

    var setText = function (sel, value) {
      var el = $(sel, builder);
      if (el) el.textContent = value;
    };
    var setValue = function (sel, value) {
      var el = $(sel, builder);
      if (el) el.value = value;
    };

    var render = function () {
      shapeEl.setAttribute('d', SHAPES[state.shape] || SHAPES.tee);
      shapeEl.setAttribute('fill', state.hex);
      hoodEl.setAttribute('d', state.shape === 'hood' ? HOOD : '');
      hoodEl.setAttribute('fill', state.hex);
      pocketEl.setAttribute('d', state.shape === 'hood' && state.area !== 'back' ? POCKET : '');

      var a = AREAS[state.area] || AREAS.front;
      areaEl.setAttribute('x', a.x);
      areaEl.setAttribute('y', a.y);
      areaEl.setAttribute('width', a.w);
      areaEl.setAttribute('height', a.h);
      labelEl.setAttribute('x', a.cx);
      labelEl.setAttribute('y', a.cy);
      labelEl.setAttribute('font-size', a.fs);
      labelEl.textContent = a.text;
      labelEl.setAttribute('fill', state.hex.toLowerCase() === '#eef2f8' ? '#0B1220' : '#EEF2F8');
      if (viewEl) viewEl.textContent = state.placement + ' view';

      setText('[data-s-garment]', state.garment);
      setText('[data-s-color]', state.color);
      setText('[data-b-color-label]', state.color);
      setText('[data-s-placement]', state.placement);
      setValue('[data-p-garment]', state.garment);
      setValue('[data-p-color]', state.color);
      setValue('[data-p-placement]', state.placement);

      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      setText('[data-s-qty]', qty);
      if (pricePerPiece) setText('[data-s-total]', money(pricePerPiece * qty, currencyCode));
    };

    var select = function (group, btn) {
      $$(group, builder).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    };

    builder.addEventListener('click', function (e) {
      var g = e.target.closest('[data-garment]');
      var c = e.target.closest('[data-color]');
      var p = e.target.closest('[data-placement]');
      if (g) {
        select('[data-garment]', g);
        state.shape = g.getAttribute('data-shape');
        state.garment = g.getAttribute('data-label');
      } else if (c) {
        select('[data-color]', c);
        state.hex = c.getAttribute('data-hex');
        state.color = c.getAttribute('data-label');
      } else if (p) {
        select('[data-placement]', p);
        state.area = p.getAttribute('data-area');
        state.placement = p.getAttribute('data-label');
      } else {
        return;
      }
      render();
    });

    if (qtyInput) {
      qtyInput.addEventListener('input', render);
      qtyInput.addEventListener('change', render);
    }

    var first = function (sel) { return $(sel + '[aria-pressed="true"]', builder); };
    var g0 = first('[data-garment]');
    var c0 = first('[data-color]');
    var p0 = first('[data-placement]');
    if (g0) { state.shape = g0.getAttribute('data-shape'); state.garment = g0.getAttribute('data-label'); }
    if (c0) { state.hex = c0.getAttribute('data-hex'); state.color = c0.getAttribute('data-label'); }
    if (p0) { state.area = p0.getAttribute('data-area'); state.placement = p0.getAttribute('data-label'); }
    render();
  }
})();
